import { render, staticRenderFns } from "./PersonContractDetail.vue?vue&type=template&id=6a776afa&scoped=true&"
import script from "./PersonContractDetail.vue?vue&type=script&lang=js&"
export * from "./PersonContractDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a776afa",
  null
  
)

export default component.exports